
import React from 'react';
import ReactDom from 'react-dom';
import {EventEmitter} from "events";
import ContactForm from "./ContactForm";
import async from 'async';
import inView from 'in-view';
import SwiperCore, { Navigation } from "swiper"; SwiperCore.use([Navigation]);

class App extends EventEmitter
{
    constructor(params) {
        super();
        params = params || {};
        this.app_url = params.app_url;
        this.api_token = params.api_token;
        this.api_endpoint = params.api_endpoint;
        this.config = params.config || {};
        this.resize_func_queue = {};
        this.translation = params.translation || {};
        this.locale = params.locale || 'ja';

        this.did_init = false;

        this.pending_queue = [];
        this.on('error', (err) => {
            console.error(err);
        });

        this.win_width;
        this.win_height;
    }

    initComponents() {
        console.log('init components');
        const self = this;
        const components = {
            '.in2-toggle-btn': ($comp) => {
                $comp.each(function(){
                    $(this).on('click', function(){
                        $(this).toggleClass('is-active');
                        $($(this).data('target')).toggleClass('is-active');
                    });
                });
            },
            '.fade-img': ($comp) => {
                $comp.each(function () {
                    if ($(this).attr('src')) {
                        const img = new Image;
                        img.onload = img.onerror = () => $(this).addClass('is-loaded');
                        img.src = $(this).attr('src');
                    }
                })
            },
            'a': ($comp) => {
                $comp.each(function () {
                    if ($(this).attr('href') && $(this).attr('href').toString().startsWith(self.app_url)
                        && $(this).attr('target') !== '_blank') {
                        $(this).on('click', function (e) {
                            e.preventDefault();
                            const $body = $('body');
                            if (!$body.hasClass('is-loading')) {
                                $body.addClass('is-loading');
                                window.location.href = $(this).attr('href');
                            }
                        });
                    }
                })
            },
            '.menu-toggle-btn': ($comp) => {
                $comp.each(function(){
                    const $body = $('body');
                    $(this).on('click', () => {
                        $comp.toggleClass('is-active');
                        $('.nav-wrap').toggleClass('is-active');
                    });
                });
            },
            '.with-active-trigger': ($comps) => {
                $comps.each(function(){
                    $(this).on('click', function(){
                        if ($(this).hasClass('is-active')) {
                            $(this).removeClass('is-active');
                        } else {
                            $(this).addClass('is-active');
                        }
                    });
                });
            },
            '#contact-form': ($comp) => {
                ReactDom.render(<ContactForm {...$comp.data()}/>, $comp.get(0));
            }
        };
        Object.keys(components).forEach((s) => {
            const $comp = $(s);
            if ($comp.length > 0) {
                try {
                    components[s]($comp);
                } catch (e) {
                    console.error(e);
                }
            }
        });
    }

    trans(key, params = {}) {
        const ret = this.translation[key];
        return ret === undefined ? key : Object.keys(params).reduce((ret, k) => {
            return ret.replace(':' + k, params[k]);
        }, ret);
    }

    ready(done) {
        if (this.did_init) {
            return done(this);
        }
        if (this.doing_init) {
            return this.pending_queue.push(done);
        }
        this.doing_init = true;
        async.parallel([
            (done) => $(document).ready(() => done()),
            (done) => $.get('/translation/' + this.locale, (res) => {
                this.translation = res;
                done();
            }),
            (done) => {
                const images = [];
                $('body').find('img').each(function(){
                    if ($(this).attr('src')) {
                        images.push($(this).attr('src'));
                    }
                });
                this.loadImages(images, done);
            }
        ], (err) => {
            this.did_init = true;

            this.win_width = $(window).innerWidth();
            this.win_height = $(window).innerHeight();

            inView.offset(parseInt($(window).innerHeight() * .15));
            inView('.in-view')
                .on('enter', (el) => {
                    $(el).addClass('in-view-enter');
                    $(el).removeClass('in-view-exit');
                })
                .on('exit', el => {
                    $(el).addClass('in-view-exit');
                    $(el).removeClass('in-view-enter');
                });

            const submit_button_cls = '.submit-button';
            $(submit_button_cls).each(function(i){
                $(this).on('click', function(e){
                    if ($(this).hasClass('is-loading') || $(this).hasClass('disabled')) {
                        return;
                    }
                    $(this).addClass('is-loading');
                    $(submit_button_cls).not(this).addClass('disabled').attr('disabled', true);
                    const target_form = $(this).data('target');
                    if (target_form) {
                        const $form = $('#' + target_form);
                        if ($form.length === 0) return console.warn('invalid form target');
                        const override = $(this).data('overrideFormData');
                        if (override) {
                            override.split('&').forEach((pair) => {
                                if (pair.indexOf(':') < 0) return;
                                const key_value = pair.split(':');
                                let val = key_value[1];
                                if (val.startsWith('(val)')) {
                                    val = $(val.substring(5)).val();
                                }
                                $form.find(`input[name=${key_value[0].trim()}]`).val(val.trim());
                            });
                        }
                        e.preventDefault();
                        e.stopPropagation();
                        $form.submit();
                        return false;
                    }
                    return true;
                });
            });

            $(window).on('resize', () => {
                const new_width = $(window).innerWidth();
                const new_height = $(window).innerHeight();

                Object.keys(this.resize_func_queue).forEach(key => {
                    const o = this.resize_func_queue[key];
                    if (!o || !o.func) return;

                    if (o.opt) {
                        if (o.opt.vertical !== undefined && new_width === this.win_width && o.opt.vertical === false) {
                            return;
                        } else if (o.opt.horizontal !== undefined && new_height === this.win_height && o.opt.horizontal === false) {
                            return;
                        }
                    }
                    const interval = o.interval || o.opt.interval || 0;
                    if (interval > 0) {
                        if (o.timer) {
                            clearTimeout(o.timer);
                            o.timer = null;
                        }
                        o.timer = setTimeout(() => o.func(), interval);
                    } else {
                        o.func();
                    }
                });

                this.win_width = new_width;
                this.win_height = new_height;
            });

            this.initComponents();

            if (typeof(done) === 'function') done(this);

            const $nav = $('.nav-wrap');
            const nav_init_height = $nav.children('div:visible').eq(0).outerHeight();
            let timer;
            const onScroll = () => {
                const top = $(window).scrollTop();
                if (top > nav_init_height) {
                    if (!$nav.hasClass('is-minimal')) {
                        $nav.addClass('is-minimal');
                        if (timer) {
                            clearTimeout(timer);
                            timer = null;
                        }
                        timer = setTimeout(() => $nav.addClass('is-shown'), 33);
                    }
                } else {
                    if ($nav.hasClass('is-minimal') && $nav.hasClass('is-shown')) {
                        $nav.removeClass('is-shown');
                        if (timer) {
                            clearTimeout(timer);
                            timer = null;
                        }
                        timer = setTimeout(() => $nav.removeClass('is-minimal'), 300);
                    }
                }
            };
            $(window).on('scroll', () => onScroll());
            onScroll();
            this.doing_init = false;
            if (this.pending_queue.length > 0) {
                async.series(this.pending_queue.map(func => done => {
                    func(this);
                    done();
                }), (err) => this.pending_queue = [])
            }
        });
    }

    createSwiper(...args) {
        return new SwiperCore(...args);
    }

    onWindowResize(key, func, options = {}) {
        this.resize_func_queue[key] = {func:func, opt:options};
    }

    loadImages(images, done, timeout = 5) {
        async.parallel(images.map(v => done => {
            const i = new Image;
            let is_timeout = false;
            const timer = setTimeout(() => {
                is_timeout = true;
                done();
            }, timeout * 1000);

            i.onload = i.onerror = () => {
                if (is_timeout) {
                    return;
                }
                if (timer) {
                    clearTimeout(timer);
                }
                done();
            }
            i.src = v;
        }), done);
    }
}

if (window) {
    window.App = App;
    if (document.fonts) {
        if (document.fonts.ready) {
            document.fonts.ready.then(() => App.font_loaded = true);
        } else {
            document.fonts.onloadingdone = () => App.font_loaded = true;
        }
    } else {
        App.font_loaded = true;
    }
    window.addEventListener('pageshow', function (event) {
        loaderCheck();
    });
    function loaderCheck() {
        const $body = $('body');
        if (!$body.hasClass('is-loading')) {
            return;
        }
        let limit = 10;
        const checker = setInterval(() => {
            console.log('check...');
            if (limit <= 0 || (App.font_loaded && app.did_init)) {
                $body.removeClass('is-loading');
                clearTimeout(checker);
            }
            limit--;
        }, 100);
    }
    loaderCheck();
}

export default App;
